import { useNavigate } from 'react-router-dom'
import { useUserContext } from '../../../../../../context/UserProvider'
import invoiceReportColumns from './invoiceReportColumns'
import type { Row } from '@tanstack/react-table'
import type { Invoice } from '../../../../../../types'
import GenericTable from '../../../../../cars/components/V3/_shared/GenericTable/GenericTable'
import { TableMobileCardContent } from '../../../../../cars/components/V3/_shared/GenericTable/TableMobileCardContent'
import { formatDate } from '../../../../../../utils/tableFuncs'
import { getConsolidateInvoiceDescription } from '../../../../../../utils/getConsolidateInvoiceDescription'

type InvoiceReportTableProps = {
  data: any
  isLoading?: boolean
}

function InvoiceReportTable({ data, isLoading }: InvoiceReportTableProps) {
  const navigate = useNavigate()
  //@ts-expect-error - remove this when UserContext is type safe
  const { handleSetConsolidateInvoice, chosenCompany } = useUserContext()

  const columns = invoiceReportColumns({ chosenCompany })

  return (
    <GenericTable
      className="max-h-[50vh]"
      isLoading={isLoading}
      data={data}
      columns={columns}
      onRowClick={(e) => {
        const invoice = e.original as Invoice
        handleSetConsolidateInvoice(invoice.consolidateInvoiceCode)
        navigate(`/reports/invoice/${invoice.invoiceNo}`)
      }}
      mobileCardContent={(row) => {
        return <MobileCardContent row={row as Row<Invoice>} chosenCompany={chosenCompany} />
      }}
    />
  )
}

export default InvoiceReportTable

function MobileCardContent({ row, chosenCompany }: { row: Row<Invoice>; chosenCompany?: string }) {
  const data = [
    {
      label: 'Fakturanr',
      value: row.original.invoiceNo || '',
    },
    {
      label: 'Samlefaktura',
      value: getConsolidateInvoiceDescription(row.original.consolidateInvoiceCode, chosenCompany) || '',
    },
    {
      label: 'Fakturadato',
      value: formatDate(row.original.postingDate) || '',
    },
    {
      label: 'Beskrivelse',
      value: row.original.consolidateDescription || '',
    },
    {
      label: 'Fakturamottaker',
      value: row.original.billToName || '',
    },
  ]
  const header = `Faktura - ${row.original.invoiceNo}`
  return <TableMobileCardContent header={header} data={data} />
}
